export const PinInput = {
  defaultProps: {
    focusBorderColor: "brand",
  },
};
